import { network } from './network';

export async function getUserInfo(opts) {
	const res = await network({
		url: '/api/v1/user_info',
		method: 'post',
		params: {},
		headers: {
			token: opts.token
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function getCheckInStatus(opts) {
	const res = await network({
		url: `/api/v1/checkin/status`,
		method: 'post',
		params: {},
		headers: {
			'Token': opts.token,
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function getAppGlobalInfo(opts) {
	const res = await network({
		url: '/api/v1/app/global',
		method: 'post',
		params: {},
		headers: {
			token: opts.token
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}
